import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userName'
})
export class UserNamePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    let capital = value[0].toUpperCase()
    let small = value.slice(1,value.length)
    let newValue = capital+small
    console.log(newValue)
    return newValue;
    // return value;
  }

}
